"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledIconButtonContent = exports.StyledIconButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0px;\n  border: 2px solid transparent;\n  background: none;\n  outline: none;\n  padding: 8px;\n  font-size: 14px;\n  display: inline;\n  border-radius: 50%;\n  cursor: pointer;\n  color: ", ";\n\n  :hover {\n    background-color: ", "40;\n    outline: none;\n  }\n\n  &.pui-icon-button--size-small {\n    font-size: 12px;\n    width: 24px;\n    height: 24px;\n  }\n\n  &.pui-icon-button--size-medium {\n    font-size: 18px;\n    width: 40px;\n    height: 40px;\n  }\n\n  &.pui-icon-button--size-large {\n    font-size: 22px;\n    width: 44px;\n    height: 44px;\n  }\n\n  &.pui-icon-button--with-margin {\n    margin: 4px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledIconButton = _styledComponents["default"].button(_templateObject(), function (props) {
  return props.color;
}, function (props) {
  return props.color;
});

exports.StyledIconButton = StyledIconButton;

var StyledIconButtonContent = _styledComponents["default"].div(_templateObject2());

exports.StyledIconButtonContent = StyledIconButtonContent;

function IconButton(_ref) {
  var size = _ref.size,
      color = _ref.color,
      className = _ref.className,
      withMargin = _ref.withMargin,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["size", "color", "className", "withMargin", "children"]);

  var theme = (0, _useTheme["default"])();

  var elementProps = _objectSpread({}, props);

  elementProps.className = (0, _clsx["default"])(className, {
    'pui-icon-button--with-margin': Boolean(withMargin)
  }, "pui-icon-button--size-".concat(size));
  elementProps.color = '#5b5b5b'; // Default color

  if (theme.palette[color] && theme.palette[color]['500']) {
    elementProps.color = theme.palette[color]['500'];
  }

  return /*#__PURE__*/_react["default"].createElement(StyledIconButton, elementProps, /*#__PURE__*/_react["default"].createElement(StyledIconButtonContent, null, children));
}

IconButton.propTypes = {
  /**
   * Icon color
   */
  color: _propTypes["default"].string,

  /**
   * Icon size
   */
  size: _propTypes["default"].string,

  /**
   * Display with margin
   */
  withMargin: _propTypes["default"].bool
};
var _default = IconButton;
exports["default"] = _default;